// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_0fd55ca845--wrapper--AIG7W","empty_list":"_0fd55ca845--empty_list--srknZ","empty_list-title":"_0fd55ca845--empty_list-title--Ung1D"};